import { render, staticRenderFns } from "./face-smile.vue?vue&type=template&id=721c2c1a&"
import script from "./face-smile.vue?vue&type=script&lang=js&"
export * from "./face-smile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports